import { render, staticRenderFns } from "./LabelManage.vue?vue&type=template&id=f0db4348&scoped=true&"
import script from "./LabelManage.vue?vue&type=script&lang=js&"
export * from "./LabelManage.vue?vue&type=script&lang=js&"
import style0 from "./LabelManage.vue?vue&type=style&index=0&id=f0db4348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0db4348",
  null
  
)

export default component.exports